<template>
  <div id="logs">
    <div id="logs-title">
      <div v-if="!!batchId" class="title-bar">
        <a-button icon="close" @click="closePage">Close</a-button>
        <h1>{{batchId}} - {{pageName}} | {{batchFormName}}</h1>
      </div>
      <div v-else class="title-bar">
        <a-icon type="arrow-left" @click="goBack" />
        <h1>{{formName}} Logs</h1>
        <a-button @click="loadLogs()" :disabled="loading">
          <a-icon type="sync" />
        </a-button>
        <a-select default-value class="select-log-type" @change="changeLogStatusType">
          <a-select-option v-for="view in viewTypes" :key="view.value">{{ view.name }}</a-select-option>
        </a-select>
      </div>
    </div>
    <a-table
      v-if="!loading"
      :rowKey="record => record.LeadGenId"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :loading="loading"
    >
      <template slot="last-request" slot-scope="requestTime, record">
        <router-link
          :to="{path:`/log-entry/${formId}/${record.LeadGenId}`}"
        >{{(requestTime)}}</router-link>
      </template>
      <template slot="mapping-status" slot-scope="status, record">
        <router-link
          :to="{path:`/log-entry/${formId}/${record.LeadGenId}`}"
          :class="{error: status.includes('Err') || status.includes('Test')}"
        >{{getStatusText(status)}}</router-link>
      </template>
      <template slot="num-of-attempts" slot-scope="retries, record">
        <router-link
          :to="{path:`/log-entry/${formId}/${record.LeadGenId}`}"
        >{{retries}}</router-link>
      </template>
      <template slot="ics-id" slot-scope="ics_id">
        <div @click="selectICSId(ics_id)" class="ics-id">{{ics_id}}</div>
      </template>
      <template slot="retry" slot-scope="status, record">
        <a
          v-if="status.includes('Err')"
          @click="!record.retrying? retryRecord(record): {}"
          :class="{retrying: record.retrying}"
        >
          <a-icon type="sync" spin v-if="record.retrying" />
          {{(record.retrying? 'Working...': 'Retry')}}
        </a>
      </template>
    </a-table>
    <a-spin size="large" v-if="loading"></a-spin>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import axios from "axios";

const sortFields = (a, b) => {
  if (a > b) {
    return -1;
  }
  if (a < b) {
    return 1;
  }
  return 0;
};

const columns = [
  {
    title: "Request Time",
    dataIndex: "CreatedAt",
    sorter: (a, b) => sortFields(a.CreatedAt, b.CreatedAt),
    scopedSlots: { customRender: "last-request" },
  },
  {
    title: "Processing Status",
    dataIndex: "StatusDate",
    key: "Status", //needs a unique key because we also use StatusDate in Retry column
    scopedSlots: { customRender: "mapping-status" },
  },
  {
    title: "Num. of Attempts",
    dataIndex: "Retries",
    scopedSlots: { customRender: "num-of-attempts" },
  },
  {
    title: "ICS ID",
    dataIndex: "ICSResponseGuid",
    scopedSlots: { customRender: "ics-id" },
  },
  {
    title: "",
    key: "Retry", //needs a unique key because we also use StatusDate in Status column
    dataIndex: "StatusDate",
    scopedSlots: { customRender: "retry" },
  },
];
export default {
  computed: {
    ...mapState(["user", "apiUrl", "formName"]),
  },
  data() {
    return {
      columns,
      data: [],
      loading: true,
      viewTypes: [
        {
          value: "",
          name: "View All Leads",
        },
        {
          value: "ErrCountry",
          name: "View Country Errors",
        },
        {
          value: "Err",
          name: "View All Errors",
        },
        {
          value: "Processed",
          name: "View All Processed",
        },
        {
          value: "ErrFB",
          name: "View Facebook Errors",
        },
        {
          value: "ErrInternal",
          name: "View Processing Errors",
        },
        {
          value: "ErrICS",
          name: "View ICS Errors",
        },
        {
          value: "Test",
          name: "View Tests",
        },
      ],
      currView: "",
    };
  },
  methods: {
    formatDate(d) {
      const date = new Date(d);
      return date.toLocaleString();
    },
    /*getLastStatus(rec) {
      if (rec.SendHttpStatus > 0) {
        return rec.SendHttpStatus;
      }
      return rec.FbHttpStatus;
    },*/
    getStatusText(code) {
      if (code.includes("Processed")) {
        return "Processed";
      } else if (code.includes("ErrFB")) {
        return "Error getting data from Facebook";
      } else if (code.includes("ErrInternal")) {
        return "Error processing data";
      } else if (code.includes("ErrICS")) {
        return "Error sending data to ICS";
      } else if (code.includes("ErrCountry")) {
        return "Error with value for country";
      } else if (code.includes("Test")) {
        return "Test Data";
      }
    },
    changeLogStatusType(val) {
      this.currView = val;
      this.loadLogs();
    },
    loadLogs() {
      this.loading = true;
      const action = this.currView === "" ? "LOGS_PER_FORM" : "LOGS_PER_STATUS";
      setTimeout(() => {
        axios({
          url: `${this.apiUrl}/logs`,
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
          params: {
            formId: this.formId,
            status: this.currView,
            action,
            batchId: this.batchId,
          },
        })
          .then((rslt) => {
            this.data = rslt.data.sort((a, b) => {
              if (a.CreatedAt > b.CreatedAt) {
                return -1;
              }
              if (a.CreatedAt < b.CreatedAt) {
                return 1;
              }
              return 0;
            });
            this.loading = false;
          })
          .catch((err) => {
            alert("Unable to load logs");
            this.loading = false;
          });
      }, 500);
    },
    retryRecord(record) {
      console.log("going to retry", record);
      Vue.set(record, "retrying", true);
      let tries = 0;
      let initial_retries = record.Retries;

      axios({
        method: "post",
        url: `${this.apiUrl}/leads`,
        headers: {
          Authorization: this.user.signInUserSession.idToken.jwtToken,
        },
        params: {
          formId: record.FormId || record.FbFormId,
          leadGenId: record.LeadGenId,
          action: "RETRY_LEADGEN",
        },
      })
        .then((retry_rslt) => {
          //Fetch status of the specific record that was retried (the Primary Type Record) every 5 seconds.
          const intervalId = setInterval(() => {
            axios({
              url: `${this.apiUrl}/logs`,
              headers: {
                Authorization: this.user.signInUserSession.idToken.jwtToken,
              },
              params: {
                formId: record.FormId || record.FbFormId,
                leadGenId: record.LeadGenId,
                action: "LOG_PER_LEADGEN",
              },
            })
              .then((update_rslt) => {
                tries++;

                //If the Retries count is greater than what is currently showing on the screen
                // then count it as having run correctly, the data should be updated for the record.
                if (update_rslt.data.Retries > initial_retries) {
                  Vue.set(record, "FbFormId", update_rslt.data.FbFormId);
                  Vue.set(record, "LeadGenId", update_rslt.data.LeadGenId);
                  Vue.set(record, "Retries", update_rslt.data.Retries);
                  Vue.set(
                    record,
                    "ICSResponseGuid",
                    update_rslt.data.ICSResponseGuid
                  );
                  Vue.set(record, "StatusDate", update_rslt.data.StatusDate);
                  Vue.set(record, "CreatedAt", update_rslt.data.CreatedAt);
                  Vue.set(record, "retrying", false);
                  clearInterval(intervalId);
                }

                // If the Retries count is still the same number then wait another 5 seconds and repeat.
                // If it goes for more than 60 seconds (12 tries) then just re-enable the Retry link (and clear the interval).
                else if (tries > 12) {
                  Vue.set(record, "retrying", false);
                  clearInterval(intervalId);
                }

                //If not met any of these 2 conditions above, just let loop the interval...
              })
              .catch((err) => {
                // If there is still an error the Retry link will be re-enabled.
                clearInterval(intervalId);
                Vue.set(record, "retrying", false);
                alert("Unable to fetch status of retry!");
              });
          }, 5000);
        })
        .catch((err) => {
          // If there is still an error the Retry link will be re-enabled.
          Vue.set(record, "retrying", false);
          alert("Unable to process retry!");
        });
    },
    // not so quick and dirty way to copy to the clipboard when clicking on the ICS ID
    selectICSId(icsId) {
      const el = document.createElement("textarea");
      el.value = icsId;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      alert(`Copied ${icsId} to the clipboard`);
    },
    closePage() {
      window.close();
    },
    goBack() {
      this.$router.back();
    },
  },
  mounted() {
    this.loadLogs();
  },
  props: ["formId", "batchId", "batchFormName", "pageName"],
};
</script>

<style lang="scss" scoped>
#title-bar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
h1 {
  margin-right: 20px;
}
.error {
  //text-transform: capitalize;
  color: #f5222d;
}
.retrying {
  color: #777;
  cursor: default;
}
.ics-id {
  user-select: none;
  cursor: pointer;
}
.select-log-type {
  width: 198px;
  margin-left: auto;
}
/*.ok {
  text-transform: uppercase;
}*/
</style>
